import store from "../store";
import { toast } from "react-toastify";
import { RESPONSE_ERROR_LOGIN, ERROR } from "../types/index";
import { showAccessDenied } from "../slices/accessDeniedSlice";

export const handleApiError = (error, showErrorToast = true) => {
  if (error?.response?.status === 401) {
    store.dispatch({ type: RESPONSE_ERROR_LOGIN });
  }

  if (error?.response?.status === 403) {
    store.dispatch(showAccessDenied(error?.response?.data));
  }

  if (showErrorToast) {
    const message =
      error?.response?.data?.message ||
      error?.errorMessage ||
      "An unexpected error occurred";

    console.log("in toast error:", message);
    toast.error(message);
  }

  store.dispatch({ type: ERROR, payload: error });
};
